import {AnalyticsEvent} from "../../../ops";

type UpdateStatusAttributes = { orderId: number, newStatus: string, reason: string };

export class UpdateStatusEvent implements AnalyticsEvent<UpdateStatusAttributes> {
    constructor(
        readonly orderId: number,
        readonly newStatus: string,
        readonly reason: string,
    ) {
    }

    getEventName(): string {
        return 'UpdateStatus';
    }

    getEventAttributes(): false | UpdateStatusAttributes | null {
        return {
            orderId: this.orderId,
            newStatus: this.newStatus,
            reason: this.reason,
        }
    }
}

export class EditOrderEvent implements AnalyticsEvent<{ orderId: number }> {
    constructor(
        readonly action: 'start' | 'complete' | 'fail',
        readonly orderId: number,
    ) {
    }
    getEventName(): string {
        return `EditOrder-${this.action}`;
    }
    getEventAttributes(): false | { orderId: number; } | null {
        return {
            orderId: this.orderId,
        }
    }
    
}